import * as mmaoActions from '@app/store/actions/mmao.action';
import { IAppState } from '@app/store';
import { Negotiation } from '@vestiaire/api-sdk-angular';

export interface IMmao {
  negotiation: Negotiation;
  commentId?: string | null;
}

export function reducer(state: IMmao, action: mmaoActions.MmaoActions) {
  switch (action.type) {
    case mmaoActions.ADD_MMAO:
      return { ...state, ...action.payload };
    case mmaoActions.REMOVE_MMAO:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const AddMmao = (state: IAppState) => state.mmao;
